import FormMultiSelect from "component/form/form_multi_select";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import { CLIENT_PERMISSIONS } from "store/string";
import { defaultClientInfoSelector } from "store/user/(default)/client/default_client.selector";

//
//component
//redux
//selector
//actions
//utils
//hook
//str

const ClientPermissions = () => {
  // -------------------------- VAR -----------------------------
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  const clientInfo = useSelector(defaultClientInfoSelector);

  // -------------------------- FUNCTION ------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN ----------------------------
  if (!clientInfo) return null;
  return (
    <FormMultiSelect
      label="Cấp quyền khách hàng"
      options={CLIENT_PERMISSIONS}
      name="clients"
      rules={[{ required: true, message: "Điền thông tin đầy đủ" }]}
      placeholder="Quyền truy cập khách hàng"
    />
  );
};
export default ClientPermissions;
